<template>
  <section class="news-detail">
    <Slogn :title1="dataSource.createTime" />
    <div class="image">
      <img :src="imageUrl">
    </div>
    <MarkComponent>
      <div class="title">
        <h4>
          {{ dataSource.title }}
        </h4>
        <!-- <h5>
          副標題目標題
        </h5> -->
      </div>
      <div class="content" v-html="dataSource.content" />
    </MarkComponent>
  </section>
</template>

<script>
import MarkComponent from '@/components/MarkComponent.vue'
import Slogn from '@/components/Slogn'
import api from '@/api'

export default {
  components: {
    MarkComponent,
    Slogn
  },
  data() {
    return {
      dataSource: {}
    }
  },
  computed: {
    imageUrl() {
      return `${process.env.VUE_APP_API_PATH}/file/getImgStream?idFile=${this.dataSource.img}`
    }
  },
  mounted() {
    this.getArticle()
  },
  methods: {
    async getArticle() {
      const params = {
        id: this.$route.params.id
      }
      const { data, success } = await api.article.detail(params)
      if (success) {
        this.dataSource = data
      }
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep.slogn {
  h2.title1  {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    span {
      padding-left: 36px;
    }
    &::before {
      top:0;
      height: 24px;
    }
  }
}
.image {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  color: $mainPurple;
  background-color: #fff;
  margin: 20px 0 ;
  text-align: center;
  img {
    width: 100%;
  }
}
.title {
  display: flex;
  h4 {
    font-size: 22px;
    color: $mainPurple;
    line-height: 1;
    margin: 0;
  }
  h5 {
    font-size: 16px;
    color: $mainGrey;
    margin-left: 16px;
  }
}

.content {
  color: $deepGrey;
  font-size: 14px;
  margin: 12px 0 0;
}

</style>
